import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { RouterStoreContext } from '../contexts/StoreContext'
import { RouterStore } from '../store/interface'

export const useRouterStore: UseStore<RouterStore> = selector => {
  return useContextStore(RouterStoreContext, selector)
}

export const useRouterStoreApi = () => {
  return useContextStoreApi(RouterStoreContext)
}
